export default __webpack_public_path__ + "static/media/qlikView-logo.669bf72c.svg";